import { type HTMLAttributes, type PropsWithChildren } from 'react'
import { type AutocompleteFreeSoloValueMapping } from '@mui/material'
import { Divider } from '../../../primitives/Divider'
import { hasOwnProperty } from '../../../helpers'
import { MenuItem } from '../../../constructs/MenuItem'
import { type AutocompleteOption } from '../model'
import { getOptionValue } from '../helpers'

type StyleProps = {
  small: boolean
  withBottomBorder: boolean
}

export type AutocompleteOptionRowProps<
  Value = AutocompleteOption<string>,
  FreeSolo extends boolean = false,
> = PropsWithChildren<
  Partial<StyleProps> & {
    liProps: HTMLAttributes<HTMLLIElement> & { key?: string }
    selected: boolean
    indeterminate?: boolean
    option: Value
    withCheckbox: boolean
    getOptionLabel: (option: Value | AutocompleteFreeSoloValueMapping<FreeSolo>) => string
    withDivider?: boolean
  }
>

export const AutocompleteOptionRow = <Value = AutocompleteOption<string>, FreeSolo extends boolean = false>({
  selected,
  liProps,
  withCheckbox,
  option,
  getOptionLabel,
  indeterminate = false,
  withDivider = false,
}: AutocompleteOptionRowProps<Value, FreeSolo>) => {
  // remove the className to prevent all the 'free bestowed' styling
  const { key, className, ...props } = liProps
  const icon = !withCheckbox && hasOwnProperty<AutocompleteOption<string>>(option, 'icon') ? option.icon : undefined

  return (
    <>
      <MenuItem<Value, boolean>
        value={option}
        key={getOptionValue<Value>(option)}
        icon={icon}
        {...props}
        selected={selected}
        withCheckbox={withCheckbox}
        indeterminate={indeterminate}
      >
        {getOptionLabel(option)}
      </MenuItem>
      {withDivider && <Divider />}
    </>
  )
}
